(ns ui.sticker-dialogs.link
  "The Replicant link sticker dialog: a link (validated, at most 245
   characters, the Instagram limit for clickable links) and an
   optional sticker name."
  (:require [storrito.editor.sticker-design :as sticker-design]
            [storrito.util.link :as link]
            [ui.sticker-dialogs.actions :as actions]
            [ui.sticker-dialogs.model :as model]
            [ui.sticker-dialogs.ui :as ui]))

(def input-class
  ["mr-2" "max-w-full" "w-full" "bg-white" "border-gray-400" "rounded" "text-gray-800"
   "shadow-sm" "focus:hover:border-gray-500" "focus:shadow-md" "grow"])

(defn initial-state
  [{:keys [data]}]
  {:link (or (:link data) "")
   :sticker-name (or (:text data) "")
   :invisible? (boolean (:invisible data))})

(defn submit-data
  [{:keys [existing] :as dialog}]
  (let [{:keys [valid? too-long?]} (model/link-state dialog)
        text (model/link-text dialog)
        data (:asset/data existing)]
    ;; `valid?` also holds for a blank link (`link/validate-weblink?`):
    (when (and valid?
               (not too-long?)
               (not (ui/blank? (:link dialog))))
      [:link-sticker (str "Linksticker-" text)
       (actions/invisible
         (assoc actions/text-sticker-base
                :type "link"
                :link (:link dialog)
                :text text
                :design (sticker-design/check-font
                          (or (:design data)
                              (first sticker-design/new-link-designs))
                          text))
         (:invisible data))])))

(defn invalid-link-hint
  []
  [:small.text-red-500.text-center.mt-1
   [:p "Invalid link. Must start with: " [:i "http://"] " or " [:i "https://"]
    ". Example: " [:i "https://app.storrito.com"]]])

(defn too-long-hint
  [url]
  [:small.text-red-500.text-center.mt-1
   [:p "Link too long. " (count url) " characters long, but only "
    link/ig-link-max-length " allowed." [:br]
    "Shorten the link or use a link shortener like "
    [:a.text-red-700.underline {:target "_blank" :href "https://bitly.com/"} "bitly.com"]]])

(defn panel
  [dialog]
  (let [{:keys [valid? too-long?]} (model/link-state dialog)]
    [:form.m-0.flex.flex-col
     {:on {:submit [[:js/prevent-default]
                    [:sticker-dialog/submit]]}}
     [:div.flex.justify-between
      [:div.mb-2.flex
       [:span.mr-1.self-center
        [:img {:style {:width "22px"} :src "/img/link-v2.svg"}]]
       [:span.self-center.text-3xl
        {:style {:font-family ui/instagram-font
                 :color "#0292ed"}}
        "LINK"]]
      [:a.inline-flex.items-center.text-gray-800
       {:href (link/help-center-url "5e9cdcbc-4ac6-4049-bf8f-70b01310f469")
        :target "_blank"
        :title "Help center article about link stickers"}
       [:i.fa.fa-info-circle]]]
     [:div.flex.p-2.flex-col.mb-2
      [:label.block.text-sm.font-medium.text-gray-700.mb-0 "Link"]
      (ui/text-field dialog
                     {:field :link
                      :dom-id "sticker-link-url"
                      :placeholder "https://storrito.com"
                      :autofocus? true
                      :class input-class
                      :style {:font-family "AvenyT"}})
      (when-not valid?
        (invalid-link-hint))
      (when too-long?
        (too-long-hint (:link dialog)))]
     [:div.flex.p-2.flex-col
      [:label.block.text-sm.font-medium.text-gray-700.mb-0 "Sticker Name (optional)"]
      (ui/text-field dialog
                     {:field :sticker-name
                      :dom-id "sticker-link-name"
                      :placeholder "Storrito"
                      :class input-class
                      :style {:font-family "AvenyT"}})]
     [:div.mt-2.flex.justify-center
      (ui/primary-button {:type "submit"
                          :disabled (or (not valid?)
                                        too-long?
                                        (ui/blank? (:link dialog)))}
                         "Add Link")]]))

(defn render
  [state]
  (when-let [dialog (actions/dialog state)]
    (panel dialog)))

(def modal
  {:modal-id :modals/editor2-link-modal
   :on-load (fn [_state] [[:sticker-dialog/init :link]])
   :sticker/kind :link
   :sticker/single-asset-type :link-sticker
   :sticker/initial-state #'initial-state
   :sticker/submit-data #'submit-data
   :render #'render})

(def register
  [modal])
